import {UserList} from "./UserList";
import {useOperationUsers} from "../api/hooks";

interface UserOperationAdminProps {
    operationId: number;
}

export const UserOperationAdmin = (props: UserOperationAdminProps) => {
    const {operationId} = props;

    const {data: users = [], isLoading} = useOperationUsers(operationId);

    return <UserList users={users} isLoading={isLoading} operationId={operationId} />
};